import React from "react";
import styled from "styled-components";

const ResponseCard = styled.div`
  position: relative;
  padding: 20px;
  margin: 20px 0px;
  background: #ececec;
  border-radius: 0 12px 12px 12px;

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
  }

  span {
    font-size: 12px;
    font-weight: 300;
  }

  p {
    padding: 5px 0;
    margin-top: 5px;
    margin-bottom: -5px;
  }
`;

const ResponseContainer = styled.div`
  position: relative;
  margin-top: 5px;
`;

export default ({ response }) => (
  <ResponseCard>
    <ResponseContainer>
      <span>REPLY FROM THE BUSINESS</span>
      <p>{response.content}</p>
    </ResponseContainer>
  </ResponseCard>
);



// WEBPACK FOOTER //
// ./src/components/Response.js